var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPictogramGroup40(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "40px",
    height: "40px",
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M3,6 C4.65685385,6 6,4.65685385 6,3 C6,1.34314615 4.65685385,0 3,0 C1.34314615,0 0,1.34314615 0,3 C0,4.65685385 1.34314615,6 3,6 Z",
    id: "path-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,5 C0,2.23857727 2.0147175,0 4.5,0 C6.9852825,0 9,2.23857727 9,5 L9,10 L0,10 L0,5 L0,5 Z",
    id: "path-3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.5,7 C5.4329975,7 7,5.4329975 7,3.5 C7,1.5670025 5.4329975,0 3.5,0 C1.5670025,0 0,1.5670025 0,3.5 C0,5.4329975 1.5670025,7 3.5,7 Z",
    id: "path-5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,6.5 C0,2.9101475 2.4624325,0 5.5,0 C8.5375675,0 11,2.9101475 11,6.5 L11,13 L0,13 L0,6.5 L0,6.5 Z",
    id: "path-7"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group40",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Search40"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-2"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Bounding-Box",
    x: 0,
    y: 0,
    width: 40,
    height: 40
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-17",
    transform: "translate(10.000000, 11.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(2.000000, 4.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-2"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-1",
    fill: "#FFFFFF",
    mask: "url(#mask-2)",
    points: "-2.30769231 -2.30769231 8.30769231 -2.30769231 8.30769231 8.30769231 -2.30769231 8.30769231"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M4.5,10 C6.15685385,10 7.5,8.65685385 7.5,7 C7.5,5.34314569 6.15685385,4 4.5,4 C2.84314569,4 1.5,5.34314569 1.5,7 C1.5,8.65685385 2.84314569,10 4.5,10 Z",
    id: "Stroke-4",
    stroke: "#4F4C4D"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-7",
    transform: "translate(0.000000, 10.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-4",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-6"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-5",
    fill: "#FFFFFF",
    mask: "url(#mask-4)",
    points: "-2.25 -2.27272727 11.25 -2.27272727 11.25 12.2727273 -2.25 12.2727273"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M0,15 C0,12.2385764 2.01471885,10 4.5,10 C6.9852825,10 9,12.2385764 9,15 L9,20 L0,20 L0,15 L0,15 Z",
    id: "Stroke-8",
    stroke: "#4F4C4D"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-11",
    transform: "translate(11.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-6",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-10"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-9",
    fill: "#FFFFFF",
    mask: "url(#mask-6)",
    points: "-2.1875 -2.1875 9.1875 -2.1875 9.1875 9.1875 -2.1875 9.1875"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M14.5,7 C16.4329975,7 18,5.4329975 18,3.5 C18,1.56700337 16.4329975,0 14.5,0 C12.5670034,0 11,1.56700337 11,3.5 C11,5.4329975 12.5670034,7 14.5,7 Z",
    id: "Stroke-12",
    stroke: "#4F4C4D"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-15",
    transform: "translate(9.000000, 7.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-8",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-14"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-13",
    fill: "#FFCC00",
    mask: "url(#mask-8)",
    points: "-2.29166667 -2.32142857 13.2916667 -2.32142857 13.2916667 15.3214286 -2.29166667 15.3214286"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M14.5,7 C17.5375675,7 20,9.91014936 20,13.5 L20,20 L9,20 L9,13.5 C9,9.91014936 11.4624339,7 14.5,7 Z",
    id: "Stroke-16",
    stroke: "#4F4C4D"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPictogramGroup40);
export default __webpack_public_path__ + "static/media/pictogramGroup40.bfec968f15fd03c2dc0d5e35ff01b3b3.svg";
export { ForwardRef as ReactComponent };